import { createReducer } from '@reduxjs/toolkit';
import { TryFetchLogTagsState, TryFetchLogTagsStatus } from './types';
import { logTagsActions } from './actions';

const initialState: TryFetchLogTagsState = {
  status: TryFetchLogTagsStatus.NotStartedYet,
  logTags: undefined,
};

export const logTagsReducer = createReducer(initialState, builder =>
  builder
    .addCase(logTagsActions.tryFetchLogTagsStart, () => {
      return { ...initialState, status: TryFetchLogTagsStatus.InProgress };
    })
    .addCase(logTagsActions.tryFetchLogTagsSuccess, (_state, action) => {
      return {
        status: TryFetchLogTagsStatus.Succeeded,
        logTags: action.payload,
      };
    })
    .addCase(logTagsActions.tryFetchLogTagsFailure, (_state, action) => {
      return {
        ...initialState,
        status: TryFetchLogTagsStatus.Failed,
      };
    })
    .addDefaultCase(state => state),
);
